import { useMutation } from '@tanstack/react-query';

import { ActivityEndpoints } from '../../../../../constants/endpoints/activityEndpoints.ts';
import { getAxios } from '../../../../../lib/axios';

export function useAddOtherCardMutation() {
  return useMutation({
    mutationFn: async (vars: { activityId: number; cardId: number }) => {
      return await getAxios().post(ActivityEndpoints.paymentCard.addOtherCard(vars.activityId, vars.cardId));
    }
  });
}
